import React, { useState } from "react";
import Navigation from "./components/Navigation";
import HomePage from "./components/HomePage";
import ChatWindow from "./components/ChatWindow";
import BuyingPage from "./components/BuyingPage";
import SellingPage from "./components/SellingPage";
import AboutPage from "./components/AboutPage";
import MissionPage from "./components/MissionPage";
import ContactPage from "./components/ContactPage";

function App() {
    const [activeTab, setActiveTab] = useState('home');

    const renderContent = () => {
        switch(activeTab) {
            case 'home':
                return <HomePage setActiveTab={setActiveTab} />;
            case 'chatbot':
                return <ChatWindow />;
            case 'buying':
                return <BuyingPage setActiveTab={setActiveTab} />;
            case 'selling':
                return <SellingPage setActiveTab={setActiveTab} />;
            case 'about':
                return <AboutPage setActiveTab={setActiveTab} />;
            case 'mission':
                return <MissionPage setActiveTab={setActiveTab} />;
            case 'contact':
                return <ContactPage setActiveTab={setActiveTab} />;
            default:
                return <HomePage setActiveTab={setActiveTab} />;
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-white via-blue-50 to-blue-100">
            <Navigation activeTab={activeTab} setActiveTab={setActiveTab} />
            <main className="main-content">
                {renderContent()}
            </main>
        </div>
    );
}

export default App;
